
// Hamburger Animation
$( ".hamburger" ).click(function() {
  $( this ).toggleClass( "is-active" );
});

$( ".js-nav-control" ).click(function() {
 	$('body').toggleClass('open');
});


// Smooth Scroll Animation
	var scroll = new SmoothScroll('a[href*="#"]');
	
	// SEARCH 

	 $('.user-icons').on("click", function(e) {
	      $('#search-pop').hide();
	});


	  $("body").on("click", '.js-show-search, .search-close', function(e) {
	    $('.search-close').css('padding-top', $('.header').height() + 100 + 'px')
	    if($('#search-pop').is(":visible") && $(window).scrollTop() == 0) {
	      $(".index .header").removeClass('header_bar');
	      $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
	    } else {
	      $(".index .header").addClass('header_bar');
	      $('.index .header .logo img').attr('src', $('.logo img').data('src'));
	    }

	    $('#search-pop').fadeToggle('fast').find('input').focus();
	    e.stopPropagation();
	    e.preventDefault();
	  });

// QTY Adjust
// Restrict the submit button to the max quantity of the product
function restrictQuantitySubmitButton() {
  if(window.Rebuy && window.Rebuy.Cart) {
    var cart = window.Rebuy.Cart.getCart();

    if(cart) {
      $("[data-add-to-cart][data-max-quantity][data-product-id]").each(function () {
        var productId = Number($(this).attr("data-product-id"));
        var item = cart.items.filter(i => i.product.id == productId)[0];
        var max = Number($(this).attr("data-max-quantity"));

        if(item) {
          var quantity = item.quantity;

          if(quantity >= max) {
            $(this).attr("disabled", true);
            $(this).css("opacity", 0.5);
            var $container = $(this).parent().parent();
            
            if($(".quantity-message").length == 0) {
              $container.append('<div class="row max-quantity-message" data-product-id="' + productId + '"><div class="col quantity-message">Max Quantity of ' + max + '</div></div>');
            }

            return;
          }
        }

        $(this).attr("disabled", false);
        $(this).css("opacity", 1);
        $("body").find('.max-quantity-message[data-product-id="' + productId + '"]').remove();

      });
    }
  }
}

document.addEventListener('rebuy:cart.change', function () {
  setTimeout(() => {
    restrictQuantitySubmitButton();
  }, 500);
});

/* JS Quantity Incrementers */
jQuery(function(){
  var j = jQuery; 
  var addInput = '.js-qty-wrap'; 

  j(addInput).each(function() { 
    var productId = j(this).attr("data-product-id");
    var inputEl = j(this).closest(addInput).find('input');
    var max = Number(inputEl.attr("max"));
    var n = inputEl.val(); 
    var plusEl = j(this).closest(addInput).find('.plus');
    var minEl = j(this).closest(addInput).find('.min');
    var validationEnabled = j(this).hasClass("validation");
    var validationTarget = j(this).data("validationTarget");
    inputEl.on("change", function() {
      var $container = inputEl.parent().parent();

      n = inputEl.val();
      if(max && n > max) {
        n = max;
        inputEl.val(max);


        if(validationEnabled) {
          if($("body").find(".quantity-message").length <= 0) {
            if(validationTarget) {
              var $validationTarget = $(validationTarget);
              $validationTarget.append("<div class='quantity-message'>Max Quantity of " + max + "</div>");
            }
            else {
              $container.append("<div class='quantity-message'>Max Quantity of " + max + "</div>");
            }
          }
        }
      }
    });
    //On plus click add 1 to n
    plusEl.on('click', function(){
      var newVal = ++n;

      var maxAllowed = max;

      // See go-cart.liquid
      if (window.MaxQuantities) {
        // Look up the max quantity for this product
        const results = window.MaxQuantities.filter(function(i) { return i.productId == productId; });

        if(results.length > 0) {
            const result = results[0];

            maxQuantity = result.maxQuantity;
        }
      }

      if(maxAllowed < 0) {
        maxAllowed = 0;
      }

      inputEl.val(newVal);
      inputEl.trigger("change");
    });
    //On min click 
    minEl.on('click', function(){
    //If n is bigger or equal to 1 subtract 1 from n 
      if ( ( inputEl.val() ) >= 1) {
        var newVal = --n;

        if(newVal < 0) {
          newVal = 0;
        }

        if(max && newVal > max) {
          n = max;
          return;
        }

        inputEl.val(newVal);
        inputEl.trigger("change");
      } 
    });
    // If a variant gets selected on the page, update the max quantity for the quantity selector
    $(".variant-option[name='id']").on("change", function() {
      if(!$(this).is(":checked")) {
        return;
      }

      var inventoryQuantity = $(this).data("inventory-quantity");
      var safetyStock = $(this).data("safety-stock");
      var maxOrderQuantity = $(this).data("max-order-quantity");

      // Inventory is not tracked:
      if (!inventoryQuantity && inventoryQuantity !== 0) {

        if(maxOrderQuantity) {
          max = maxOrderQuantity;
          inputEl.prop("max", max);
        }
        else {
          max = null;
          inputEl.prop("max", "");
        }

        return;
      }

      // If inventory is tracked, we should use whichever is lesser:
      // - The current inventory level with safety stock subtracted
      // - The max order quantity (if set)
      var availableInventory = Math.max(inventoryQuantity - safetyStock, 0);
      var maxQuantity = maxOrderQuantity ? Math.min(availableInventory, maxOrderQuantity) : availableInventory;

      // Update the max quantity for the quantity selector
      max = maxQuantity;
      inputEl.prop("max", max);
    });
    // Trigger the change event for all variants on the page.
    // This is done because there can be a default selected variant on the page.
    // The selected variant causes the max quantity to get applied.
    $(".variant-option[name='id']").trigger("change");
  });
});
  


// Footer Nav

function resizeHandler() {
  if ($(window).width() < 767) {    
    $('.footer-nav ul').hide();
    $('.footer-nav ul').slideUp(200);
  } else{
     $('.footer-nav ul').show();
     $('.footer-nav-header').removeClass("expanded");
  }
 }

resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function() { 
  if ($(window).width() < 767) {
    $(this).next().slideToggle(200);
    $(this).toggleClass("expanded");
  }
});

//FAQ
$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});





// TINY SLIDER 
if (document.querySelectorAll('.js-announce-carousel').length > 0) {
  const currentBox = tns({
    container: '.js-announce-carousel',
    items: 1,
    nav: false,
    controls: true,
    mouseDrag: true
  });

}

// TINY SLIDER 
if (document.querySelectorAll('.js-announce-carousel-auto').length > 0) {
  const announceSlide = tns({
    container: '.js-announce-carousel-auto',
    items: 1,
    nav: false,
    controls: true,
    mouseDrag: true,
    autoplay: true,
    autoplayHoverPause: true,
    autoplayButtonOutput: false
  });

}



if (document.querySelectorAll('.js-current-box-carousel').length > 0) {
  const currentBox = tns({
    container: '.js-current-box-carousel',
    items: 1,
    nav: true,
    controls: true,
    mouseDrag: true,
    controlsPosition: "top",
    navPosition: "bottom",
    responsive: {
      640: {
        edgePadding: 0,
        gutter: 36,
        items: 1
       
      },
      700: {
        gutter: 36,
        items: 2,
        navPosition:"top"

      },
      900: {
        items: 3,
        slideBy: 3,
        navPosition:"top"
      }
    }
  });

}

if (document.querySelectorAll('.js-carousel').length > 0) {
document.querySelectorAll('.js-carousel').forEach(slider => {
    tns({
        container: slider,
        // options here
        items: 1,
    	nav: true,
    	controls: true,
    	navPosition: "bottom",
        controlsPosition: "top",
    	mouseDrag: true,
    	responsive: {
      640: {
        edgePadding: 0,
        gutter: 36,
        items: 1
      },
      700: {
        gutter: 22,
        items: 2,

      },
      900: {
        items: 3
      }
    }
    });
});
    }


if (document.querySelectorAll('.js-products-carousel').length > 0) {
  const productsFeatured = tns({
    container: '.js-products-carousel',
    loop: false,
    nav: true,
    controls: true,
    mouseDrag: true,
    controlsPosition: "bottom",
    navPosition: "bottom",
    responsive: {
      640: {
        edgePadding: 0,
        gutter: 36,
        items: 1
       
      },
      700: {
        gutter: 36,
        items: 2,
        navPosition:"bottom"

      },
      900: {
        items: 3,
        slideBy: 3,
        navPosition:"bottom"
      }
    }
  });

}

$(document).on('click', '.js-pop-prod-select', function(e){
  
  e.preventDefault();
  const $boxCotainer = $(this).closest('.js-products-pop-container');
  $boxCotainer.find('.js-pop-prod-select.selected').text('Select')
  $boxCotainer.find('.js-pop-prod-select.selected').removeClass('selected');

  $(this).addClass('selected');
  $(this).text('Selected')
  
})


// $(document).on('lity:close', function() {
//   console.log('lity closed ', $(this))
//   const $boxCotainer = $('.js-products-pop-container');
//   if($boxCotainer) {
//     $boxCotainer.find('.js-pop-prod-select').removeClass('selected');
//     $boxCotainer.find('.js-pop-prod-select').text('Select')
//   }
// });

// $(document).on('click', '[data-lity-close]', function() {
//   const $boxCotainer = $(this).closest('.js-products-pop-container');
//   $boxCotainer.find('.js-pop-prod-select').removeClass('selected');
//   $boxCotainer.find('.js-pop-prod-select').text('Select')
// })


// Initialize selected items when modal open Button is clicked

//if (document.getElementsByClassName('js-modal-open-btn').length > 0) {
  document.querySelectorAll(".js-modal-open-btn").forEach(button=>{
    button.addEventListener("click",(e)=>{
  //$(document).on('click', '.js-modal-open-btn', function(e){
    if (e.target.getAttribute("data-gift-ids")) {
      let ids =  e.target.getAttribute("data-gift-ids").split(",");
      if(e.target.getAttribute("data-has-member-choice")) {
        const $memberChoiceContainer = $(e.target).closest('.js-member-choice-modal-container');
        const $selectedMemberChoice = $memberChoiceContainer.find('.js-pop-color-select.selected')
        const memberChoiceVariantId = $selectedMemberChoice.data('variantid')
        if(memberChoiceVariantId){
          ids.push(memberChoiceVariantId);
        }
      }
     
      if (ids.length>0) {
        autoAdd(ids,e.target);
        e.preventDefault();
        return;
      }
    }
    const $boxCotainer = $('.js-products-pop-container');
    if($boxCotainer) {
      $boxCotainer.find('.js-pop-prod-select').removeClass('selected');
      $boxCotainer.find('.js-pop-prod-select').text('Select')
    }
  });
});
//}


function autoAdd(ids,element) {
  let rNum = generateID();
  let data = {
    items: [
      {
        "id": element.getAttribute("data-variant-id"),
        "quantity": 1,
        "selling_plan": element.getAttribute("data-selling-plan"),
        "properties": {
          '_box_num': rNum
        }
      }
    ]
  };
  if(!window.cart.items.find(item=>item.properties["_free_prod"]=="true")) {
    ids.map(id => {
      data.items.push({
        quantity: 1,
        id: id,
        "properties": {
          '_free_prod': "true",
          '_free_prod_num': rNum
        }
      });
    })
  }
  addItemsToCart(data,element);
}

function validateFreeGiftChoiceSelected(isGiftPage, choiceModal, memberChoiceVariantId){
  const nonGiftOptions = choiceModal.querySelectorAll('.js-pop-color-select:not([disabled])');
  const giftOptions = choiceModal.querySelectorAll('.js-pop-prod-select:not([disabled])');
  const currentOptions = isGiftPage ? giftOptions : nonGiftOptions;

  if((choiceModal && !memberChoiceVariantId) && currentOptions?.length > 0) {
    //show notification for users to choose a member choice
    $('.js-member-choice-force-text p').addClass('show');
    return false;
  }

  $('.js-member-choice-force-text p').removeClass('show');
  return true;
}

// Ajax Add to Cart without opening any Modals
document.querySelectorAll(".js-plan-join-btn").forEach(element=>{
  element.addEventListener("click",(e)=>{
    e.preventDefault();
    const selectedBoxVariantId = element.getAttribute('data-variantid');
    const sellingPlan = element.getAttribute('data-selling-plan');
    const choiceModal = e.target.closest('.js-member-choice-modal-container');
    const selectedOption =  choiceModal?.querySelector('.js-pop-color-select.selected');
    const memberChoiceVariantId = selectedOption?.dataset.variantid;
    const giftIds = e.target.getAttribute("data-gift-ids");

    if(choiceModal && !validateFreeGiftChoiceSelected(false, choiceModal, memberChoiceVariantId)){
      return;
    }
    
    let data = {}
    if(memberChoiceVariantId ) { // if it has member choice variants
      // This random ID must be used to associate ALL free gifts/choices associated with this box
      const rNum = generateID();
      data = {
        items: [
          {
            "id": selectedBoxVariantId,
            "quantity": 1,
            "selling_plan": sellingPlan,
            "properties": {
              '_box_num': rNum,
              '_tag':element.getAttribute("data-use-promo-code")||""
            }
          },
          {
            quantity: 1,
            id: memberChoiceVariantId,
            "properties": {
              '_free_prod': "true",
              '_free_prod_num': rNum
            }
          }
        ]
      };

      if (giftIds != null) {
        let giftIdsArray = giftIds.split();
        if (!window.cart.items.find((item) => item.properties["_free_prod"] == "true")) {
          giftIdsArray.map((id) => {
            data.items.push({
              quantity: 1,
              id: id,
              properties: {
                _free_prod: "true",
                _free_prod_num: rNum,
              },
            });
          });
        }
      }
      
      addItemsToCart(data,element);
    } else if (selectedBoxVariantId){
      let qty = 1;
      data = {
        "id": selectedBoxVariantId,
        "quantity": qty,
        "selling_plan": sellingPlan,
        "properties": {
          '_tag':element.getAttribute("data-use-promo-code")||""
        }
      }
      addItemsToCart(data,element);
    }  else{
    }
  });
});

// Ajax Add to Cart without Gifts
document.querySelectorAll(".js-plan-atc-btn").forEach(element=>{
  element.addEventListener("click",(e)=>{
    e.preventDefault();
    const $boxCotainer = $(element).closest('.js-products-pop-container');
    const $selectedBox = $boxCotainer.find('.js-pop-prod-select.selected')
    const selectedBoxVariantId = $selectedBox ? $selectedBox.data('variantid') : ""
    const sellingPlan = $selectedBox ? $selectedBox.data('selling-plan') : "";
    
    if(selectedBoxVariantId && sellingPlan){
      let qty = 1;
      data = {
        "id": selectedBoxVariantId,
        "quantity": qty,
        "selling_plan": sellingPlan,
        'properties':{
          '_tag':element.getAttribute("data-use-promo-code")||subscription_tracking_code
        }
      }
  
      addItemsToCart(data,element);
    }
    else if(!selectedBoxVariantId) {
      alert('Please select a box --- 1')
    }
    else{
    }
  });
});

// Ajax Add to Cart on Gift modal
document.querySelectorAll(".js-gift-atc-btn").forEach(element=>{
  element.addEventListener("click",(e)=>{
    console.error(element);

    e.preventDefault();

    const choiceModal = e.target.closest('.subscription-plan-modal-container');
    const selectedOption =  choiceModal.querySelector('.js-pop-prod-select.selected');
    const memberChoiceVariantId = selectedOption?.dataset.variantid;

    if(!validateFreeGiftChoiceSelected(true, choiceModal, memberChoiceVariantId)){
      return;
    }
  
    // Check if there is a box choice
    const blockId = $(element).data('blockid');
    const $boxCotainer = $(`#variant_pop_${blockId}`);
  
    let selectedBoxVariantId = "";
    let sellingPlan = "";
  
    if($boxCotainer) {
      const $selectedBox = $boxCotainer.find('.js-pop-prod-select.selected')
      selectedBoxVariantId = $selectedBox ? $selectedBox.data('variantid') : ""
      sellingPlan = $selectedBox ? $selectedBox.data('selling-plan') : "";
    }
    
    if(!selectedBoxVariantId || !sellingPlan) {
      //if there is no box choice which means to add only the first variant of the subscription
      selectedBoxVariantId = $(element).data('variantid');
      sellingPlan = $(element).data('selling-plan');
    }

    const $giftConainer = $(e.currentTarget).closest('.js-products-pop-container');
    const $selectedGift = $giftConainer.find('.js-pop-prod-select.selected')
    const selectedGiftVariantId = $selectedGift ? $selectedGift.data('variantid') : ""
  
    
    console.error([$selectedGift,selectedGiftVariantId]);

    let data = {};
    let rNum = generateID();
    let subscription_tracking_code = "";
    if (element.getAttribute("data-use-promo-code") && element.getAttribute("data-use-promo-code").length>0) {
      subscription_tracking_code=element.getAttribute("data-use-promo-code");
    }
  
    if(selectedGiftVariantId) { //Addtocart with gifts
      data = {
        items: [
          {
            "id": selectedBoxVariantId,
            "quantity": 1,
            "selling_plan": sellingPlan,
            "properties": {
              '_box_num': rNum,
              '_tag':subscription_tracking_code
            }
          },
          {
            quantity: 1,
            id: selectedGiftVariantId,
            "properties": {
              '_free_prod': "true",
              '_free_prod_num': rNum
            }
          }
        ]
      };
    }else { //Addtocart without gifts
      data = {
        "id": selectedBoxVariantId,
        "quantity": 1,
        "selling_plan": sellingPlan,
        'properties':{
          '_tag':subscription_tracking_code
        }
      }
    }
    
  
    if(selectedBoxVariantId && sellingPlan){
      addItemsToCart(data,element);
    }
    else if(!selectedBoxVariantId) {
      alert('Please select a box --- 2')
    }
    else{
    }
  })
});

// When click 
$(document).on('click', '.js-open-gift-pop-btn', function(e){
  e.preventDefault();
  const $boxCotainer = $(this).closest('.js-products-pop-container');
  const $selectedBox = $boxCotainer.find('.js-pop-prod-select.selected')
  const selectedBoxVariantId = $selectedBox ? $selectedBox.data('variantid') : ""
  const sellingPlan = $selectedBox ? $selectedBox.data('selling-plan') : "";
  
  if(!selectedBoxVariantId){
    alert('Please select a box --- 3')
    return;
  }
})


const addItemsToCart = (data,element) => {
  if (element.getAttribute("data-use-promo-code") && element.getAttribute("data-use-promo-code").length>0) {
    if (typeof data == "object") {
      data.properties["_tag"] = element.getAttribute("data-use-promo-code");
    } else {
      data.items.forEach(item=>item.properties['_tag'] = element.getAttribute("data-use-promo-code"));
    }
  }
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(data) { 
      $('[data-lity-close]').trigger('click');
      if (element.getAttribute("data-dtc")=="true") {
        var cart = {
          bundleItems: false,
        }
        if(data.items && data.items.length > 0) {
          cart.bundleItems = true;
          var item = data.items[0]
          if (item !== 'undefined') {
            cart = Object.assign(cart, item)
          }
          cart.items = data.items
          
        }else {
          cart = Object.assign(cart, data)
        }
        _learnq.push(['track', 'Added to Cart', cart])    
        location.href="/checkout"; 
      } else {
        goCart.addItemToCartHandler(data);
      }
    },
    error: function(error) { 
      goCart.ajaxRequestFail()
    }
  });
}


//Random Number Generator
const generateID =  () => {
  let uniqueValue = (new Date()).getTime() + Math.trunc(365 * Math.random())

  return uniqueValue
}



/**
 * @ Homepage Hero Slider JS
 */
if (document.querySelectorAll('.js-component-slider').length > 0) {
  var heroSlider = tns({
    container: '.js-component-slider',
    items: 1,
    nav: true,
    navPosition: 'bottom',
    controls: false,
    mouseDrag: true,
    loop: false,
    //rewind: true,
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 5000
  })
}

/**
 * @ Color Selection JS
 */
$(document).on('click', '.js-pop-color-select', function(e){
  e.preventDefault();

  let boxContainer, productSelectBtns, memberChoiceForceText;
  
  boxContainer = e.currentTarget.closest('.js-member-choice-modal-container');
  productSelectBtns = boxContainer.querySelectorAll('.js-pop-color-select:not(:disabled)');
  memberChoiceForceText = boxContainer.querySelector('.js-member-choice-force-text p')

  productSelectBtns.forEach((btn) => {
    btn.classList.remove('selected');
    btn.innerText = btn.dataset.selectTranslation;
  });
  
  e.currentTarget.classList.add('selected');
  e.currentTarget.innerText = e.currentTarget.dataset.selectedTranslation;
  
  memberChoiceForceText.classList.remove('show');
})

// PDP
const slider = document.querySelector('[data-pdp-slider]'); 
if(slider) {
  window.simpleslider = tns({
    container: slider,
    mode: 'carousel',
    controls: false,
    loop: true,
    navContainer: '[data-pdp-slider-nav]',
    navAsThumbnails: true,
    preventScrollOnTouch: 'auto',
    preventActionWhileRunning: true,
    speed: 400,
    mouseDrag: true
  });
   
 var thumbs = tns({
    container: '[data-pdp-slider-nav]',
    items: 4,
    controls: true,
    center: true,
    nav:false,
    mouseDrag: true,
      responsive: {
        700: {
          items: 6
        }
      
      }
    });
  function syncthumbs(info) {
    thumbs.goTo(info.displayIndex);
  }
  window.simpleslider.events.on("dragEnd",(info,event)=> {
    syncthumbs(info);
  });
  window.simpleslider.events.on("touchEnd",(info,event)=> {
    syncthumbs(info);
  });

}

//Handle Login form redirects
//See https://www.froonze.com/blog/how-to-redirect-customers-after-login-or-registration-in-shopify
document.addEventListener('DOMContentLoaded', function() {
    var REDIRECT_PATH = '/account';

    //Check for returnurl parm in URL
    const urlParams = new URLSearchParams(window.location.search);
    const returnUrl = urlParams.get('returnurl');

    // If we have a return URL redirect there after login
    if (returnUrl) {
          REDIRECT_PATH = returnUrl;
    } 

    var selector = '#create_customer, #customer_login',
    $signForm = document.querySelector(selector);

    if ($signForm) {
      $redirect = document.createElement('input');
      $redirect.setAttribute('name', 'return_to');
      $redirect.setAttribute('type', 'hidden');
      $redirect.value = REDIRECT_PATH;
      $signForm.appendChild($redirect);
    }
  },false);

  $(document).on("lity:open", function (event, instance) {
    $("body").addClass("modal-open");
  });

  $(document).on("lity:close", function (event, instance) {
    $("body").removeClass("modal-open");
  });
